/**
 * Event configuration constants for frontend
 */
export const MAX_EVENT_LOCATIONS = 8;
